import { parseAddress } from "./account/consent";
import { useGame } from "./game/useGame";
import { useParent } from "./game/useParent";
import { GameScreen } from "./ui/GameScreen";
import { ParentScreen } from "./ui/ParentScreen";

/** The game: the logic comes from `useGame`, everything on screen from `GameScreen`. */
function Game() {
  return <GameScreen {...useGame()} />;
}

/** The page a parent opens from a link (`/parent?token=...`): no game state is loaded. */
function Parent({ address }: { address: ReturnType<typeof parseAddress> }) {
  const { view, actions } = useParent(address);
  return <ParentScreen view={view} actions={actions} />;
}

export function App() {
  const address = parseAddress(window.location.search, window.location.pathname, window.location.hash);
  return address.page === "parent" ? <Parent address={address} /> : <Game />;
}
